import { observer } from "mobx-react";
import TranslationScope from "../../../../../../translation/translation-scope";
import useTranslation from "../../../../../../translation/hooks/translation-hook";
import { useEffect } from "react";
import usePage from "../../../../../../components/layouts/base-page-layout/page-hook";
import LocateShipmentEditor from "./locate-shipment-editor";

const LocateShipmentEditorPage: React.FC = observer(() => {
    const { setSubTitles } = usePage();

    useEffect(() => {
        setSubTitles(['Portal', 'Content', 'Locate Shipment']);
    }, [setSubTitles]);

    const { selectedLocale } = useTranslation();
    
    return (
        <TranslationScope scope="tracking-portal" locale={selectedLocale}>
            <LocateShipmentEditor />
        </TranslationScope>
    );
});

export default LocateShipmentEditorPage;